//import { defineCustomElement } from 'vue'
//import AccountSummary from './components/AccountSummary.vue';
//import PageToolbar from './components/PageToolbar.vue';
import SignInSignOut from './components/SignInSignOut.vue';
import TwoFactorAuth from './components/account/TwoFactorAuth.vue';
import twoFactorService from './utils/TwoFactorService';
import dialogManager from './utils/DialogManager';
/*
import WeatherSummaryComponent from './components/WeatherSummary.vue';
import WeatherSummary2Component from './components/WeatherSummary2.vue';
*/

// Import our custom CSS
import './scss/styles-minimal.scss'


import { createApp } from 'vue'
import { createI18n } from 'vue-i18n';



//export { createApp, WeatherSummary2Component };

//createApp(WeatherSummary2Component).mount('#app')
console.log("loading main-corecomponents..." );

let VcCoreComponentLoader = (function(){
  
   
    let language = document.getElementsByTagName("html")[0].getAttribute("lang");
    console.log("Starting VcCoreComponentLoader... language = " + language);
    
    let i18n = createI18n({
        locale: language,
        fallbackLocale: 'en',
        //messages:VcAccountComponentMsgs
        
    })

    const CORECOMPONENTS={
        'SignInSignOut':SignInSignOut,
        'TwoFactorAuth':TwoFactorAuth,
    };

    window.VcAvailableComponents=(window.VcAvailableComponents && { ...window.VcAvailableComponents, ...CORECOMPONENTS }) || CORECOMPONENTS;

     //register the 2FA services
    window.twoFactorService = twoFactorService;


    let isReady=false;

    window.addEventListener("load",function(event) {
        isReady=true;

        attachComponents();
        
    },false);

    function attachComponents() {
        if (!window.VcComponents) {
            console.log("No VcComponents found..." );
            return;
        }

        window.VcComponents.forEach(item => {
            if (!window.VcAvailableComponents[item.component]) {
                console.log("Component not found..." +item.component);
                return;
            }
            console.log("Component being mounted..." +item.component);
            const app=createApp(window.VcAvailableComponents[item.component]); 
            app.use(i18n);
            app.mount(item.selector)
        });
    }
})();



